import React, { useEffect, useRef } from 'react';
import {
  MdStorefront, MdCardGiftcard, MdLocalOffer,
  MdAccountBalanceWallet, MdSwapHoriz, MdBarChart
} from 'react-icons/md';
import './Features.css';

const features = [
  { icon: <MdStorefront />, title: 'Store Management', desc: 'Manage multiple store branches from one centralized dashboard with real-time updates.', color: '#1f78b9' },
  { icon: <MdCardGiftcard />, title: 'Loyalty Points', desc: 'Automatically award points on every purchase and keep customers coming back.', color: '#00c853' },
  { icon: <MdLocalOffer />, title: 'Offers & Promotions', desc: 'Create targeted offers, discounts, and bonus point campaigns to boost sales.', color: '#f59e0b' },
  { icon: <MdAccountBalanceWallet />, title: 'Customer Wallet', desc: 'Every customer gets a digital wallet to track their points, history, and rewards.', color: '#a855f7' },
  { icon: <MdSwapHoriz />, title: 'Redemption System', desc: 'Simple and instant point redemption at checkout — in-store or via app.', color: '#67b7f7' },
  { icon: <MdBarChart />, title: 'Reports & Analytics', desc: 'Deep insights on customer behavior, store performance, and revenue trends.', color: '#ef4444' },
];

function useReveal(ref) {
  useEffect(() => {
    const els = ref.current?.querySelectorAll('.reveal');
    if (!els) return;
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('revealed'); observer.unobserve(e.target); } }),
      { threshold: 0.12 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [ref]);
}

export default function Features() {
  const ref = useRef(null);
  useReveal(ref);

  return (
    <section className="features" id="features" ref={ref}>
      <div className="features__bg-dots" />
      <div className="container text-center">
        <span className="section-label reveal">Features</span>
        <h2 className="section-title reveal" style={{ transitionDelay: '0.05s' }}>
          Everything You Need to Run<br />a Loyalty Program
        </h2>
        <p className="section-subtitle reveal" style={{ transitionDelay: '0.1s' }}>
          From setup to analytics — Pointfinity handles the full loyalty lifecycle for your stores.
        </p>
        <div className="features__grid">
          {features.map((f, i) => (
            <div
              key={f.title}
              className="feature-card reveal"
              style={{ transitionDelay: `${0.1 + i * 0.08}s` }}
            >
              <div className="feature-card__icon" style={{ background: f.color + '18', color: f.color }}>
                {f.icon}
              </div>
              <h3 className="feature-card__title">{f.title}</h3>
              <p className="feature-card__desc">{f.desc}</p>
              <div className="feature-card__line" style={{ background: f.color }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
